import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function PromotionNotFound() {
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Not found"
      description="It may have been deleted, or the link is out of date."
      action={
        <Button variant="outline" asChild>
          <Link to="/campaigns">Back to campaigns</Link>
        </Button>
      }
    />
  );
}
